/* eslint-disable default-case */
import React, { useState } from 'react';
import './../css/auth.scss';
import Logo from './../assets/images/logo_auth.png';
import Axios from 'axios';
import { useParams } from 'react-router';
import { API } from '../api/api';
import { ClipLoader } from 'react-spinners';
import LogoResetPassword from './../assets/images/informasi-harga.png';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import FormResetPassword from '../components/FormResetPassword';

const ResetPassword = () => {
  const MySwal = withReactContent(Swal);

  const { key } = useParams();

  const [reset, setReset] = useState({
    password: '',
    password_confirm: '',
  });


  const [error, setError] = useState({
    password: {
      error: false,
      msg: '',
    },
    password_confirm: {
      error: false,
      msg: '',
    },
  });

  const [isReset, setIsReset] = useState(false);
  const [success, setIsSuccess] = useState(false);

  const [passwordScore, setPasswordScore] = useState({
    password: 0,
    passwordConfirm: 0,
  });

  const onCheckDisabled = () => {
    let disabled1 = true;
    let disabled2 = false;
    let disabled3 = true;

    if (reset.password != '' && reset.password_confirm != '') disabled1 = false;
    else if (reset.password == '' || reset.password_confirm == '') disabled1 = true;

    if (error.password.error == false && error.password_confirm.error == false) disabled2 = false;
    else if (error.password.error == true || error.password_confirm.error == true) disabled2 = true;

    if (passwordScore.password >= 2 && passwordScore.passwordConfirm >= 2) disabled3 = false;
    else disabled3 = true;

    if (disabled1 == false && disabled2 == false && disabled3 == false) return false;
    else return true;
  };

  const onChange = (event) => {
    switch (event.target.name) {
      case 'password':
        setReset({ ...reset, password: event.target.value });
        event.target.value == ''
          ? setError({
            ...error,
            password: { error: true, msg: 'Kata Sandi baru diperlukan!' },
          })
          : event.target.value.length < 8
            ? setError({
              ...error,
              password: {
                error: true,
                msg: 'Kata sandi baru minimal berjumlah 8 karakter!',
              },
            })
            : event.target.value !== reset.password_confirm
              ? setError({
                ...error,
                password_confirm: {
                  error: true,
                  msg: 'Kata sandi baru dan konfirmasi kata sandi baru tidak sama',
                },
                password: { error: false, msg: '' },
              })
              : setError({
                ...error,
                password_confirm: { error: false, msg: '' },
                password: { error: false, msg: '' },
              });
        break;

      case 'password_confirm':
        setReset({ ...reset, password_confirm: event.target.value });
        event.target.value == ''
          ? setError({
            ...error,
            password_confirm: {
              error: true,
              msg: 'Konfirmasi Kata Sandi baru diperlukan',
            },
          })
          : event.target.value.length < 8
            ? setError({
              ...error,
              password_confirm: {
                error: true,
                msg: 'Kata sandi baru minimal berjumlah 8 karakter!',
              },
            })
            : event.target.value !== reset.password
              ? setError({
                ...error,
                password_confirm: {
                  error: true,
                  msg: 'Kata sandi baru dan konfirmasi kata sandi baru tidak sama',
                },
              })
              : setError({ ...error, password_confirm: { error: false, msg: '' } });
        break;
    }
  };

  const onReset = async () => {
    if (reset.password === reset.password_confirm) {
      setIsReset(true);

      try {
        await Axios.post(API.reset_password, {
          enc: key,
          password: reset.password,
          url: window.location.origin + '/login',
        })

        setIsSuccess(true);

        MySwal.fire({
          title: 'Pesan',
          icon: 'success',
          text: 'Pengaturan ulang kata sandi berhasil',
        });
      } catch (error) {

        MySwal.fire({
          title: 'Pesan',
          icon: 'error',
          text: 'Pengaturan ulang kata sandi tidak berhasil',
        });
      } finally {
        setIsReset(false);

      }




    }
  };

  return (
    <>
      <div className="page">
        <div className="main container-fluid">
          <div className="row">
            <div className="col-lg-8 col-md-12 d-flex align-items-start">
              <div className="px-5 pt-5 mt-5">
                <img height="80" width="80" src={Logo} alt='Market Auction Price' />
                <h3 className="mt-3 text-light">Market Auction Price</h3>
                <p className="mt-3 pr-5 text-light">
                  Market Auction Price (MAP) adalah aplikasi yang menyediakan informasi harga pasaran mobil lelang
                  terlengkap di Indonesia. Buatlah keputusan yang tepat dan menguntungkan, karena semua informasi harga
                  pasaran mobil yang mau Anda beli atau jual ada disini.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 px-5 py-4">
              {isReset && (
                <div className="form-group form-login bg-white rounded d-flex justify-content-center align-items-center  py-5 h-100">
                  <ClipLoader loading size={100} />
                </div>
              )}
              {!isReset && (
                !success ? (
                  <div className="form-group form-forget bg-white rounded py-3 px-4">
                    <h4 className="mb-4">Reset Password</h4>
                    <FormResetPassword onChange={(event) => {
                      onChange(event);
                    }} onSubmit={onReset} onChangeScore={(score) => {
                      setPasswordScore({ ...passwordScore, password: score });
                    }} disabled={onCheckDisabled()} error={error} values={reset} />
                  </div>
                ) : (
                  <div className="form-group form-forget bg-white rounded py-3 px-4">
                    <h4 className="mb-4">Atur Ulang Kata Sandi</h4>
                    <p className="mb-2 mt-4">
                      Sukses, Mohon <a href="/login">login disini</a> dengan kata sandi baru
                    </p>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="page-mobile">
        <div className="container-fluid">
          <div className="row d-flex justify-content-center pt-5" style={{ backgroundColor: '#f0f0f0' }}>
            <img style={{ width: '80%', height: '60%' }} src={LogoResetPassword} alt='Reset Password' />
          </div>
          <div className="row pt-3">
            <div className="col-12 mt-2">
              <h4 className="mb-4">Reset Password</h4>
              <FormResetPassword onChange={(event) => {
                onChange(event);
              }} onSubmit={onReset} disabled={onCheckDisabled()} error={error} values={reset} />

              <p className="mb-2 mt-4">
                Silahkan login <a href="/login"> di sini</a> dengan kata sandi baru
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
